import type { DocumentRecord } from "../../types/record";
import { ResultCard } from "./ResultCard";
import { EmptyState } from "../EmptyState";
import { ResultsSkeleton } from "../ResultsSkeleton";

interface SearchResultsProps {
  results: DocumentRecord[];
  isLoading: boolean;
  total: number;
  page: number;
  onPageChange: (page: number) => void;
  hasNextPage: boolean;
  from: number;
  to: number;
}

export function SearchResults({
  results,
  total,
  isLoading,
  page,
  from,
  to,
  hasNextPage,
  onPageChange,
}: SearchResultsProps) {
  if (isLoading) {
    return <ResultsSkeleton />;
  }

  if (results.length === 0) {
    return <EmptyState />;
  }

  const pageSize = 10;
  const totalPages = Math.ceil(total / pageSize);

  return (
    <div className="mt-8 w-full max-w-2xl">
      <div className="flex items-center justify-between text-left mb-4">
        <p className="text-sm text-white">Showing {total} results</p>
        {/* <div className="flex items-center gap-2">
          <button
            onClick={() => onPageChange(page - 1)}
            disabled={page <= 0}
            className="px-2 py-1 text-sm text-white disabled:opacity-50"
          >
            Previous
          </button>
          <span className="text-sm text-white">
            Page {page + 1} of {totalPages}
          </span>
          <button
            onClick={() => onPageChange(page + 1)}
            disabled={!hasNextPage}
            className="px-2 py-1 text-sm text-white disabled:opacity-50"
          >
            Next
          </button>
        </div> */}
      </div>
      <div className="space-y-4">
        {results.map((result) => (
          <ResultCard key={result.id} result={result} />
        ))}
      </div>
    </div>
  );
}
